<div class="appheader">
    <header class="mdc-top-app-bar pc">
        <div class="topbread-wrap">
            <div class="tophead-wrap">
                <div class="tophead container"><a [routerLink]="['/user/auction']"><img class="serv-logo" src="assets/img/brand/logo.png?v=2" [alt]="'user.logo_alt' | transloco"></a>
                    <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button headmenuicon"> menu</button>
                    <ul class="s-nav">
                        <li><a>{{ 'user.user_guide' | transloco }}</a></li>
                        <li class="guideline_menu_parent"><a>{{ 'user.guidelines' | transloco }}</a>
                            <ul class="guideline_menu">
                                <li class="guideline_item"><a>{{ 'user.auction' | transloco }}</a></li>
                                <li class="guideline_item"><a>{{ 'user.brand_auction' | transloco }}</a></li>
                            </ul>
                        </li>
                        <li class="nav-sp"><a>{{ 'user.fee_list' | transloco }}</a></li>
                        <li class="nav-sp"><a>{{ 'user.bank_account_list' | transloco }}</a></li>
                        <li><a href="https://active-net-auction-market.com/contact-us/">{{ 'user.contact_us' | transloco }}</a></li>
                        <li><app-languages></app-languages></li>
                        <li><span><a href="#" (click)="logout()"><i class="fa fa-lock" style="color: red"></i> {{ 'user.logout' | transloco }}</a></span></li>
                    </ul>
                </div>
                <div class="nav-sp-wrap" id="submenu">
                    <ul class="nav-sp">
                        <li><a [routerLink]="['/user/item']">{{ 'user.item_list' | transloco }}</a></li>
                        <li><a [routerLink]="['/user/auction']">{{ 'user.auction_info' | transloco }}</a></li>
                        <li><a [routerLink]="['/user/summary']">{{ 'user.settlement_info' | transloco }}</a></li>
                        <li><a [routerLink]="['/user/user']">{{ 'user.member_info' | transloco }}</a></li>
                        <li><a> <span class="mainbar-btn-item">{{ 'user.enter_auction_hall' | transloco }}</span> </a></li>
                        <li><a> <span class="mainbar-btn-item">{{ 'user.output_settlement_statement' | transloco }}</span> </a></li>
                        <li><a><span class="mainbar-btn-item">{{ 'user.favorite_item_list' | transloco }}</span></a></li>
                        <li class="s-nav-item"><a href="https://active-net-auction-market.com/about-us/" target="_blank">{{ 'user.company_profile' | transloco }}</a></li>
                        <li class="s-nav-item"><a>{{ 'user.user_guide' | transloco }}</a></li>
                        <li class="s-nav-item" id="guideline_sp"><a class="header-to-guideline">{{ 'user.guidelines' | transloco }}</a>
                            <ul class="guideline_menu_sp">
                                <li class="guideline_item_sp"><a>{{ 'user.auction' | transloco }}</a></li>
                                <li class="guideline_item_sp"><a>{{ 'user.brand_auction' | transloco }}</a></li>
                            </ul>
                        </li>
                        <li class="s-nav-item"><a>{{ 'user.fee_list' | transloco }}</a></li>
                        <li class="s-nav-item"><a>{{ 'user.bank_account_list' | transloco }}</a></li>
                        <li class="s-nav-item"><a href="https://active-net-auction-market.com/terms-of-service/">{{ 'user.terms_of_service' | transloco }}</a></li>
                        <li class="s-nav-item"><a href="https://active-net-auction-market.com/contact-us/">{{ 'user.contact_us' | transloco }}</a></li>
                        <li class="s-nav-item"><a href="javascript: void(0);" onclick="Application.logout();"><i class="fas fa-lock" style="color: red"></i> {{ 'user.logout' | transloco }}</a></li>
                    </ul>
                </div>
            </div>
            <div class="breadcrumbs-list">
                <div class="breadcrumbs container">
                    <div class="breadcrumb breadcrumb-position" style="display: flex;">
                        <ul class="container">
                            <li><a [routerLink]="['/user/auction']">{{ 'user.home' | transloco }}</a></li>
                            <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last=last>
                                <li *ngIf="breadcrumb.label.title&&breadcrumb.url.substring(breadcrumb.url.length-1) == '/' || breadcrumb.label.title&&last" [ngClass]="{active: last}">
                                    <a *ngIf="!last" [routerLink]="breadcrumb.url">{{breadcrumb.label.title | transloco}}</a>
                                    <span *ngIf="last">{{breadcrumb.label.title | transloco}}</span>
                                </li>
                            </ng-template>`
                        </ul>
                    </div>
                    <div class="breadcrumb vendor-data" *ngIf="user">
                        <div class="container vendor">{{user.memberName}} / {{user.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mainbar-wrap" style="display: block;">
            <div class="container">
                <ul class="mainbar">
                    <li class="menutop">
                        <ul class="menutoplist">
                            <li class="current"><a [routerLink]="['/user/items']">{{ 'user.item_list' | transloco }}</a></li>
                            <li><a [routerLink]="['/user/auction']">{{ 'user.auction_info' | transloco }}</a></li>
                            <li><a [routerLink]="['/user/summary']">{{ 'user.settlement_info' | transloco }}</a></li>
                            <li><a [routerLink]="['/user/user']">{{ 'user.member_info' | transloco }}</a></li>
                        </ul>
                    </li>
                    <li>
                        <ul class="mainbar-btn-container">
                            <li class="mainbar-btn auction_menu_parent"><a [routerLink]="['/user/live']">{{ 'user.auction_hall' | transloco }}</a>
                                <ul class="auction_menu">
                                    <li>{{ 'user.enter' | transloco }}</li>
                                    <li>{{ 'user.settle' | transloco }}</li>
                                </ul>
                            </li>
                            <li class="mainbar-btn" style="text-align: left"><a [routerLink]="['/user/items']" [queryParams]="{mode: 'お気に入り'}">{{ 'user.favorite_items' | transloco }}</a></li>
                            <li class="mainbar-btn" *ngIf="can(CAPS.ONLINE_ADMIN)" style="text-align: left"><a [routerLink]="['/admin']">{{ 'user.admin_screen' | transloco }}</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</div>
<div class="app-body">
    <main class="main">
        <router-outlet></router-outlet>
    </main>
</div>
<footer class="app-footer">
    <span class="float-xs-right">
        Powered by <a href="https://www.kobe-ap.com/">株式会社アクティブプロモーション</a>{{ 'user.footer_subsidy' | transloco }}
    </span>
</footer>
